import { render, staticRenderFns } from "./ReportingMain.vue?vue&type=template&id=550c676f&scoped=true&"
import script from "./ReportingMain.vue?vue&type=script&lang=js&"
export * from "./ReportingMain.vue?vue&type=script&lang=js&"
import style0 from "./ReportingMain.vue?vue&type=style&index=0&id=550c676f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c676f",
  null
  
)

export default component.exports